import React from 'react';
import { CtaButton } from './CtaButton';
import { Reassurance } from './Reassurance';
import { CHECKOUT_URL } from '../data/content';
export function PriceSection() {
  return <section id="precio" className="w-full scroll-mt-4 bg-brand-deep px-4 py-12 sm:px-6 sm:py-20" data-id="element-84" data-mp="39ihmq8kkpmep">
      <div className="mx-auto max-w-xl text-center" data-id="element-85" data-mp="35hfnhrqnpacq">
        <p className="font-display text-xs font-extrabold uppercase tracking-wider text-violet-300 sm:text-sm" data-id="element-86" data-mp="35gnrwgx27cmg">
          Valor real del programa completo
        </p>
        <p className="mt-1 font-display text-3xl font-extrabold text-violet-300/70 line-through sm:text-4xl" data-id="element-87" data-mp="2vhoobcr5i76b">
          $157 USD
        </p>
        <p className="mt-2 text-xs text-violet-200 sm:text-sm" data-id="element-88" data-mp="2qlpydkq6ch3s">
          6 tomos ($97) + 5 bonus ($60)
        </p>

        <p className="mt-7 font-display text-sm font-extrabold uppercase tracking-wider text-white sm:mt-8 sm:text-base" data-id="element-89" data-mp="osa1w77eo80w">
          Precio especial de lanzamiento hoy
        </p>
        <p className="mt-1 font-display text-[3.5rem] font-black leading-none text-white sm:text-7xl" data-id="element-90" data-mp="kokgfqm126k3">
          $27
          <span className="align-top text-xl font-extrabold sm:text-3xl" data-id="element-91" data-mp="1rhp78dykaxfr">
            {' '}
            USD
          </span>
        </p>

        <p className="mx-auto mt-4 inline-block rounded-full bg-accent px-4 py-2 font-display text-[0.8rem] font-extrabold uppercase tracking-wide text-white sm:mt-5 sm:px-5 sm:text-base" data-id="element-92" data-mp="1diz7sro9slo8">
          Ahorras $130 USD comprando hoy
        </p>

        <div className="mt-7 sm:mt-8" data-id="element-93" data-mp="25b6mvno4nq0i">
          <CtaButton href={CHECKOUT_URL} external location="precio" data-id="element-94" data-mp="2a8q5t0vrsqys">
            ¡Sí, quiero reiniciar mi metabolismo ahora!
          </CtaButton>
        </div>

        <Reassurance className="mt-4" tone="dark" items={['Un solo pago', 'Acceso inmediato', 'Acceso de por vida', '100% digital', 'Sin suscripciones']} data-id="element-95" data-mp="1wez42eoa6bdm" />

        <p className="mx-auto mt-6 max-w-md rounded-xl border border-white/20 bg-white/5 px-4 py-3.5 text-[0.9rem] leading-relaxed text-violet-100 sm:px-5 sm:py-4 sm:text-base" data-id="element-96" data-mp="2t094wwmobkvj">
          Incluye los <strong className="font-semibold text-white" data-id="element-97" data-mp="2yuecshz1wtql">6 tomos</strong>{' '}
          + <strong className="font-semibold text-white" data-id="element-98" data-mp="2tt748gp33qiv">5 bonus</strong> + plan
          de 9 días + Plan Maestro de 30 días.
        </p>
      </div>
    </section>;
}